import { AbstractControl, ValidatorFn } from '@angular/forms';

// These two countries were decided based on the db where ic_phone_cc_prefix = 1
export function vueUsaCanadaPhoneFormatValidator(): ValidatorFn {
	return (control: AbstractControl) => {
		const lengthOfNumbers: number[] = (control.value || '').split('').filter(char => !isNaN(char) && char !== ' ');

		return !control.value || lengthOfNumbers.length === 10 ? null : { vueUsaCanadaPhoneFormat: true };
	};
}
